import scoreSetSettingsEvents from "./scoreSetSettingsEvent";

const INIT_STATE = {
  loading: true,
  requesting: false,
  fixedProviders: ['GOOGLE', 'FACEBOOK', 'YELP']
};

function isScoreSet(newScore, oldScore) {
  return newScore.scoreConfig._id.$oid === oldScore.scoreConfig._id.$oid;
}

export const scoreSettingsReducer = (state = {...INIT_STATE}, action)  => {
  let newState;
  switch(action.type){
    case scoreSetSettingsEvents.SCORE_INIT:
      newState  = {...state, ...action.data, loading: false};
      break;
    case scoreSetSettingsEvents.SCORE_SET_API_REQUEST:
      newState = {...state, requesting: true};
      break;
    case scoreSetSettingsEvents.CREATE_SCORE_SET:
      newState =  {...state};
      newState.scoreSets = [...newState.scoreSets, ...[action.data]];
      break;
    case scoreSetSettingsEvents.UPDATE_SCORE_SET:
      newState = {...state};
      newState.scoreSets = [...newState.scoreSets];
      for(let i = 0; i < newState.scoreSets.length; i++){
        if(isScoreSet(newState.scoreSets[i], action.data)){
          newState.scoreSets[i] = action.data;
          break;
        }
      }
      break;
    case scoreSetSettingsEvents.DELETE_SCORE_SET:
      newState = {...state};
      newState.scoreSets = [...newState.scoreSets];
      for(let i = 0; i < newState.scoreSets.length; i++){
        if(isScoreSet(newState.scoreSets[i], action.data)){
          newState.scoreSets.splice(i, 1);
          break;
        }
      }
      break;
    case scoreSetSettingsEvents.RELOAD_SCORE_SETS:
      newState = {...state, requesting: false, scoreSets: action.data };
      break;
    default:
      newState = state;
  }
  return newState;
};
